import React from "react";
import { IAMExceptionType, IAMExceptionTypeToComponentMap } from "../../types";
import Button from "../../ui/widgets/button";
import { useMessageSource } from "react-message-source";

interface RegistrationIamExceptionProps {
  exception: IAMExceptionType;
  handleOnClick: () => void;
}

const RegistrationIamException: React.FC<RegistrationIamExceptionProps> = ({
  exception,
  handleOnClick,
}: RegistrationIamExceptionProps) => {
  const { getMessage } = useMessageSource();

  const ExceptionComponent = IAMExceptionTypeToComponentMap[exception];
  return (
    <ExceptionComponent
      renderButton={() => {
        return (
          <Button kind="primary" onClick={handleOnClick}>
            {getMessage("Error.tooManyOtpAttempts.button")}
          </Button>
        );
      }}
    />
  );
};

export default RegistrationIamException;
